import { RequestPayload } from "appworks/model/gameplay/requests/request-payload";

export class RespinRequestPayload extends RequestPayload { }
